import React, { useState, useEffect, useRef } from "react";
import { Card, CheckmarkCircleIcon, Button } from "@pancakeswap/uikit";
import { motion } from "framer-motion";
import "./Roadmap.css";

const roadmapData = [
  { id: 1, title: "Multi chain", description: "Launch the ETH token and create the ETH swap", status: "done", month: "April" },
  { id: 2, title: "One-way bridge", description: "Build the BNB → ETH bridge", status: "done", month: "April" },
  { id: 3, title: "VIZSLA Chart System", description: "Every chart will run on our own custom-built system, providing full control and unique visualization.", status: "done", month: "May" },
  { id: 5, title: "Earning on the ETH chain", description: "Participate in VIZSLASWAP liquidity mining and start earning rewards on the Ethereum chain", status: "inprogress", month: "May" },
  { id: 4, title: "ETH → BNB Bridge",description: "Full freedom to move VizslaSwap tokens between ETH and BNB networks", status: "inprogress", month: "May" },
  { id: 6, title: "Website Speed Optimization", description: "Maximizing website loading speed to deliver the smoothest possible user experience.", status: "inprogress", month: "May" },
  { id: 7, title: "Third Network Integration", description: "Introducing a third blockchain network, chosen through community vote.", status: "inprogress", month: "June" },
  { id: 8, title: "Chat Upgrade & Mobile App", description: "Further development of the chat system and launch of the mobile application.", status: "inprogress", month: "July" },
];              

const statusColor = {
  done: "border-green-400",
  inprogress: "border-yellow-400",
  pending: "border-gray-500",
};

const RoadmapSlider: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [visibleCards, setVisibleCards] = useState(1);
  const [currentCard, setCurrentCard] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) setVisibleCards(1);
      else if (width < 1024) setVisibleCards(2);
      else setVisibleCards(3);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToCard = (index: number) => {
    const container = scrollRef.current;
    if (container) {
      const card = container.querySelectorAll<HTMLElement>(".roadmap-card-wrapper")[index];
      if (card) {
        const containerRect = container.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const scrollOffset = cardRect.left - containerRect.left - 16; // padding offset
        container.scrollTo({ left: container.scrollLeft + scrollOffset, behavior: "smooth" });
        setCurrentCard(index);
      }
    }
  };

  const handlePrev = () => {
    if (currentCard > 0) {
      scrollToCard(currentCard - 1);
    }
  };

  const handleNext = () => {
    if (currentCard < roadmapData.length - 1) {
      scrollToCard(currentCard + 1);
    }
  };

  return (
    <div className="roadmap-wrapper">
            <h2 className="roadmap-title">Roadmap</h2>

      <div className="roadmap-slider-container" ref={scrollRef}>
        <div className="roadmap-slider-track">
          {roadmapData.map((item) => (
            <motion.div
              key={item.id}
              whileHover={{ scale: 1.05 }}
              className="roadmap-card-wrapper"
            >
<Card className={`roadmap-card ${statusColor[item.status]} ${item.status === "done" ? "done-shadow" : ""}`}>
<div className="roadmap-icon">
  {item.status === "done" && (
    <div className="status-done">
      <CheckmarkCircleIcon width="24px" color="#efcb5d" />
      <span className="done-label">SUCCESSFUL</span>
    </div>
  )}
  {item.status === "inprogress" && (
    <div className="status-inprogress">
      <div className="status-dot inprogress" />
      <span className="inprogress-label">PROCESSING</span>
    </div>
  )}
  {item.status === "pending" && <div className="status-dot gray" />}
</div>

                <p className="roadmap-month">{item.month}</p>
                <h3 className="roadmap-title-item">{item.title}</h3>
                <p className="roadmap-description">{item.description}</p>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="roadmap-controls">
        <Button onClick={handlePrev} disabled={currentCard === 0} scale="sm" variant="secondary" mr="15px" mt="10px">
          ←
        </Button>
        <Button onClick={handleNext} disabled={currentCard === roadmapData.length - 1} scale="sm" variant="gold" mt="10px">
          →
        </Button>
      </div>
    </div>
  );
};

export default RoadmapSlider;
